import React, { useCallback } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const ConfirmationDialog = ({ open, options, onCancel, onConfirm }) => {
  const {
    title,
    description,
    confirmationText,
    cancellationText,
    dialogProps,
    confirmationButtonProps,
    cancellationButtonProps,
  } = options;

  return (    
    <Dialog fullWidth {...dialogProps} open={open} onClose={onCancel} className="custom-alert-box-inject">
      {title && (
        <DialogTitle>{title}</DialogTitle>
      )}
      {description && (
        <DialogContent>
          <DialogContentText>{description}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>       
        <Button color="primary" {...confirmationButtonProps} onClick={onConfirm} className="btn btn-success">
          {confirmationText}
        </Button>
        <Button color="primary" {...cancellationButtonProps} onClick={onCancel} className="btn btn-primary" autoFocus>
          {cancellationText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
